//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'ExceedBulletin',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {},
  data: function data() {
    return {
      autoLoadInit: false,
      pagePath: '/online/warn',
      pageTitle: '超标快报',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        dataIndex: 'warnTime',
        colName: 'warn_time',
        title: '预警时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'factorName',
        colName: 'factor_name',
        title: '因子名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'factorVal',
        colName: 'factor_val',
        title: '监测数值',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'warnContent',
        colName: 'warn_content',
        title: '预警内容',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'exceedMultiple',
        colName: 'exceed_multiple',
        title: '超标比例',
        align: 'center',
        sorter: true,
        customRender: function customRender(text) {
          if (null != text) {
            return text * 100 + '%';
          } else {
            return text;
          }
        }
      }, {
        dataIndex: 'warnStatus_dictText',
        colName: 'warn_status',
        title: '预警状态',
        align: 'center',
        sorter: true
      }],
      url: {
        list: '/online/warn/exceed',
        checkBatch: '/online/warn/checkBatch',
        delete: '/online/warn/deleteBatch'
      }
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData(); // if (window.sessionStorage.getItem('siteType')) {
      //   this.getCol(window.sessionStorage.getItem('siteType'))
      // }
    }
  },
  created: function created() {},
  computed: {},
  methods: {
    loadData: function loadData(arg) {
      //this.queryParam.st = window.sessionStorage.getItem('siteType')
      this.initTableData(arg);
    },
    onDateWarnTime: function onDateWarnTime(value, dateArray) {
      this.queryParam.stime = dateArray[0];
      this.queryParam.etime = dateArray[1];
    },
    handleCheck: function handleCheck(record) {
      var ids = record.id;
      var that = this;
      this.$confirm({
        title: '解除',
        content: '是否解除选中数据?',
        onOk: function onOk() {
          getAction(that.url.checkBatch, {
            ids: ids
          }).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.loadData();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          });
        }
      });
    },
    batchCheck: function batchCheck() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择' + this.pageTitle + '记录！');
        return;
      } else {
        var ids = '';

        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }

        var that = this;
        this.$confirm({
          title: '解除',
          content: '是否解除选中' + this.pageTitle + '数据?',
          onOk: function onOk() {
            getAction(that.url.checkBatch, {
              ids: ids
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadData();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    }
  }
};